<template>
  <div class="topNav">
    <div class="nav-bg">
      <div class="top-nav">
        <!--<div class="fl"><span class="top-pos"><i class="el-icon-location"></i>成都</span> <span>［切换城市］</span></div>-->
        <div class="fr">
          <ul class="top-right">
            <li @click="goLogin()" v-if="!$store.getters.user.nickName">您好，请登录</li>
            <li class="user" :class="{'enter-center':isShowCenterEntrance}" v-if="$store.getters.user.phone" @mouseover="isShowCenterEntrance=true" @mouseout="isShowCenterEntrance=false">
              <p>{{$store.getters.user.phone}}  <i class="el-icon-arrow-down"></i></p>
              <p v-show="isShowCenterEntrance"><button type="button" @click="$router.push({'path':'/center/index'})">账号管理</button></p>
              <p v-show="isShowCenterEntrance"><button type="button" @click="loginOut()">退出登录</button></p>
            </li>
            <li @click="goReg()" v-if="!$store.getters.user.nickName">免费注册</li>
            <router-link tag="li" :to="{path:'/center/order'}" class="active">我的订单</router-link>
            <li @click="openAgreement()">用户须知</li>
            <li class="line">|</li>
            <li @click="businessApply()" v-if="!$store.getters.user.shopId"  class="active">商家申请</li>
            <router-link tag="li" :to="{path:'/business'}" v-if="$store.getters.user.shopId" class="active">我是商家</router-link>
            <router-link tag="li" :to="{path:'/session'}" class="active">我的消息</router-link>
            <li class="line">|</li>
            <li class="app-down">
              APP下载
              <div class="app-cont">
                <img src="../../assets/images/qrCode.png" alt="" class="qr-img">
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <loginDialog ref="loginDialog"></loginDialog>

  </div>


</template>

<script>
  import loginDialog from '../../components/dialog/login'
  import {getShopExamineInfo} from '../../api/shop'
export default {
  name: 'topNav',
    data(){
      return {
          isShowCenterEntrance:false,//登陆后是否显示个人中心入口
      }
    },
    components:{
        loginDialog,
    },
    computed: {
    },
    mounted(){
    },
    methods:{
        openAgreement(){
            window.open('https://admin.mingrenminglan.com/dictionary/noJwt/agreement');
        },
        goLogin(){
            this.$store.commit('changeLoginShow',true);
            this.$refs.loginDialog.showType=1;
        },
        goReg(){
            this.$store.commit('changeLoginShow',true);
            this.$refs.loginDialog.showType=3;
        },
        loginOut(){
            this.$confirm('此操作将退出登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.$store.dispatch('logout');
                this.$message({
                    type: 'success',
                    message: '成功退出!'
                });
            })

        },
        businessApply(){
            getShopExamineInfo().then(res=>{
                if(res.data){
                    if(res.data.status===1){
                        this.$router.push({path:'/business/apply'})
                    }else{
                        this.$message({
                            message: res.data.status==0?'待审核':'审核拒绝',
                            type: 'error',
                            duration: 5 * 1000
                        })
                    }
                }else {
                    this.$router.push({path:'/business/apply'})
                }
            })

        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '../../assets/css/common';
  .topNav{
    background-color:#ffffff;
    .nav-bg{
      background-color:#FBFBFB;
      font-size:14px;
      height:34px;
      line-height:34px;
      .top-nav{
        @include main-content;
        overflow: hidden;
        .fl{
          .top-pos{
            color:$main-color
          }
        }
        .el-icon-arrow-down{
          transition: all .3s;
        }
        .enter-center{
          background-color:#fff;
          position: absolute;
          top:0;
          left:0;
          border:1px solid #DDDDDD;
          border-top:none;
          padding-bottom:30px;
          .el-icon-arrow-down{
            -webkit-transform: rotate(180deg);
            -moz-transform: rotate(180deg);
            -ms-transform: rotate(180deg);
            -o-transform: rotate(180deg);
            transform: rotate(180deg);
          }
          }
        .top-right{
          color:#9A9EA7;
          li{
            float: left;
            margin-right:30px;
            text-align: center;
            &:hover{color:$main-color;
              cursor: pointer;}
            &.user{
              position: relative;
              width:132px;
            }
            &.app-down{
              width:100px;
              &:hover .app-cont{
                display: block;
              }
            }
            .app-cont{
              display: none;
              position: relative;
              background-color: #ffffff;
              margin: 10px 0;
              width: 100px;
              height: 100px;
              line-height: 43px;
              color: white;
              text-align: center;
              border-radius: 10px;
              -webkit-box-shadow: 3px 3px 5px #9A9EA7;
              -moz-box-shadow: 3px 3px 5px #9A9EA7;
              box-shadow: 3px 3px 5px #9A9EA7;
              &:after{
                content: '';
                position: absolute;
                width: 0;
                height: 0;
                border: 8px solid transparent;
                border-bottom-color: #ffffff;
                left: 50%;
                bottom: 100%;
                margin-left: -10px;
              }
              .qr-img{
                width:80px;
                margin-top: 10px;
              }
            }
          }
        }
      }
    }
    .topSearch{
      @include main-content;
      overflow: hidden;
      padding:15px 0 30px;
      .logo{
        width:195px;
        height:48px;
        margin-right:153px;
        background-color:$main-color
      }
      .search-cont{
        margin-top:5px;
        border:2px solid $main-color;
        line-height:34px;
        .search-list{
          border:none;
          width:60px;
          color:#000000;
          font-weight: 600;
          margin-left:5px;
        }
        .select-inp{
          width:306px;
          padding-left:10px;
          line-height:30px;
        }
        .btn-search{
          float: right;
          height:35px;
          width:85px;
          background-color:$main-color;
          color: #ffffff;
        }
      }
    }
    .type-nav{
      height:33px;
      line-height:33px;
      .type-list{
        @include main-content;
        li{
          width:80px;
          float: left;
          color:#575757;
          font-size:16px;
          font-weight:600;
          text-align: center;
          margin-left:24px;
          cursor: pointer;
          &:hover{color:$main-color;}
          &.title{background-color:$main-color;color: #ffffff;width:210px;
            line-height: 33px;margin-left:0;}
          &.active-link.router-link-exact-active{
            color:$main-color;
          }
        }
      }
    }
    .active.router-link-exact-active{color:$main-color;}
  }


</style>
<style lang="scss">
  @import '../../assets/css/common';
  .btn-addArticle.el-button{
    background-color:$main-color;
    color:#ffffff;
    border:none;
    margin-right:80px;

  }
  .btn-addArticle.el-button.is-round{
    width:140px;
    height:48px;
    font-size:20px;
    -webkit-border-radius: 24px;
    -moz-border-radius: 24px;
    border-radius:24px;
  }
  .btn-addArticle.el-button.is-round:hover{
    color:#ffffff;
    background-color:$main-color;
  }
</style>
